/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exporting_ResultsInputs */



/**
* | output |
* | --- |
* | "Exporting results..." |
*
* @param {Exporting_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const exporting_results = /** @type {((inputs?: Exporting_ResultsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exporting_ResultsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation des résultats...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ergebnisse werden exportiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione dei risultati...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Результаты экспорта...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportando resultados...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在导出结果...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("結果をエクスポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिणामों का निर्यात किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportando resultados...")
	return /** @type {LocalizedString} */ ("Exporting results...")
});